import { Typography } from '@material-ui/core'
import ContractIcon from '@material-ui/icons/Assignment'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/TemplateAddHeader.styles'

export const TemplateAddHeader = () => {
  const { templateID } = useParams<{ templateID: string }>()
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <ContractIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {templateID
          ? getTranslate('Template')
          : getTranslate('Create New Template')}
      </Typography>
    </div>
  )
}
